import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RangeValueType } from '@/shared/types/antd';

import type { TradingPlatformSchema } from '../types/trading-platform.schema';

const initialState: TradingPlatformSchema = {
    dateRange: null,
    selectedAsset: null,
};

const tradingPlatformSlice = createSlice({
    name: 'tradingPlatform',
    initialState,
    reducers: {
        changeDateRange: (
            state,
            action: PayloadAction<Nullable<RangeValueType<DateString>>>,
        ) => {
            state.dateRange = action.payload;
        },
        changeSelectedAsset: (state, action: PayloadAction<string | null>) => {
            state.selectedAsset = action.payload;
        },
    },
});

export const {
    actions: tradingPlatformActions,
    reducer: tradingPlatformReducer,
} = tradingPlatformSlice;
